module.exports = __webpack_public_path__ + "img/hm_logo_blue.4968b2d5.png";